import React, { useState, useEffect } from 'react'
import FormActionButtons from '../../../../Shared/FormAction/FormActionButtons'
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Form, Schema } from 'rsuite';
import Information from '../../../../Shared/Card/Information';
import { GetReinstatementInformationContent } from '../../../../Shared/InformationContent/PlsInformation';
import EmploymentLicensure from '../../../../Shared/Card/EmploymentLicensure';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import employmentService from '../../../../../services/Internal/Reinstatement/PLS/employment.service';
import reinstatementService from '../../../../../services/Internal/Reinstatement/reinstatement.service';
import { getVfCredential } from '../../../../../services/Shared/codeTable.service';
import Issues from '../../../../Shared/Card/Issues';
import entityService from '../../../../../services/Internal/Staff/entity.service';
import FormEntityInformation from '../../../Shared/FormEntityInformation';

function EmploymentPage() {
    const [sectionData, setSectionData] = useState({});
    const [hasLoaded, setHasLoaded] = useState(false);
    const push = useNavigate();
    const { StringType, ObjectType } = Schema.Types;
    const [option, setOption] = useState();
    const sectionId = 2;
    const routes = useSelector(x => x.currentRoutes);
    const store = useSelector(x => x);
    const [isComplete, setIsComplete] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Professional Land Surveyor Reinstatement",
            isIndividual: true,
            entityId: 0,
            applicationDate: "",
            currentSection: "Employment"
        }
    );

    const [formModel, setFormModel] = useState({
        id: 0,
        reinstatementId: store.currentApplicationId,
        employedBy: '',
        licensedFirmType: '',
        firmNumber: null,
        comment: ''
    })


    useEffect(() => {
        setHasLoaded(false);
        employmentService.getEmployment(store.currentApplicationId).then((response) => {
            reinstatementService.plsGetSection(store.currentApplicationId, sectionId).then((data) => {
                reinstatementService.getIndividualReinstatement(store.currentApplicationId).then((reinstatementData) => {
                    setIsUserEditable(reinstatementData.data.status.id == 2)
                    entityService.getEntity(data.data.entityId).then((entity) => {
                        setEntityInfo(
                            {
                                ...entityInfo,
                                lolaNum: entity.data.lolaNumber,
                                entityName: entity.data.formattedName,
                                entityId: entity.data.entityId,
                                licenseNumber: reinstatementData.data?.credential?.formattedLicenseNumber,
                                applicationDate: reinstatementData.data?.dateSubmitted,
                                formType: reinstatementData.data?.isOverFiveYears ? "Professional Land Surveyor Reinstatement (5 plus years)" : entityInfo.formType
                            })
                    });
                    setSectionData(data.data);
                    setIsComplete(data.data.staffReviewComplete)
                    if (response.data) {
                        var licensedFirmType = "";
                        if (response.data.firmIsLicensed)
                            licensedFirmType = "licensed";
                        else if (response.data.firmIsNotLicensed)
                            licensedFirmType = "unlicensed";
                        else if (response.data.soleProprietor)
                            licensedFirmType = "soleProprietor";
                        else if (response.data.unemployed)
                            licensedFirmType = "unemployed"
                        if (response.data.credentialId) {
                            getVfCredential(response.data.credentialId).then((cred) => {
                                setFormModel({
                                    id: response.data.id,
                                    employedBy: response.data.employedByName,
                                    firmNumber: cred?.value,
                                    comment: response.data.comment,
                                    licensedFirmType: licensedFirmType
                                });
                                setOption(licensedFirmType);
                            })
                        }
                        else {
                            setFormModel({
                                id: response.data.id,
                                employedBy: response.data.employedByName,
                                firmNumber: response.data.credentialId,
                                comment: response.data.comment,
                                licensedFirmType: licensedFirmType
                            });
                            setOption(licensedFirmType);
                        }
                    }
                    setHasLoaded(true);
                })
            });
        })

    }, [])
    const model = Schema.Model({
        licensedFirmType: StringType().isRequired('This field is required'),
        comment: StringType().when(schema => {
            const { value } = schema.licensedFirmType;
            return value === 'soleProprietor' ? StringType().isRequired('This field is required.') : StringType();
        }),
        firmNumber: ObjectType().when(schema => {
            const { value } = schema.licensedFirmType;
            return value === 'licensed' ? ObjectType().isRequired('This field is required.') : ObjectType();
        }),
        employedBy: StringType().when(schema => {
            const { value } = schema.licensedFirmType;
            return value === 'unlicensed' ? StringType().isRequired('This field is required.') : StringType();
        })
    });
    const formSubmit = (validation, event) => {
        var hasErrors = false;
        var validationObject = model.check(formModel);
        for (const key in validationObject) {
            if (validationObject[key].hasError) {
                if (key === "firmNumber" && formModel.licensedFirmType === "licensed") {
                    hasErrors = true;
                    return
                }
                else if (key === "employedBy" && formModel.licensedFirmType === "unlicensed") {
                    hasErrors = true;
                    return
                }
                else if (key === "comment" && formModel.licensedFirmType === "soleProprietor") {
                    hasErrors = true;
                    return
                }
                else if (key === "licensedFirmType") {
                    hasErrors = true;
                    return
                }
            }
        }
        if (!hasErrors) {
            submitData();
        }
    }

    const clearFirmNumber = () => {
        setFormModel({ ...formModel, firmNumber: null });
    }

    const submitData = (isForSubmit) => {
        var dataTransfer = {
            id: formModel.id,
            reinstatementId: store.currentApplicationId,
            comment: formModel.comment,
            credentialId: formModel.firmNumber ? formModel.firmNumber.licenseNumber : null,
            employedByName: formModel.employedBy,
            entityId: store.currentApplicationEntityId,
            firmIsLicensed: formModel.licensedFirmType ? formModel.licensedFirmType == "licensed" ? true : false : null,
            firmIsNotLicensed: formModel.licensedFirmType ? formModel.licensedFirmType == "unlicensed" ? true : false : null,
            soleProprietor: formModel.licensedFirmType ? formModel.licensedFirmType == "soleProprietor" ? true : false : null,
            unemployed: formModel.licensedFirmType ? formModel.licensedFirmType == "unemployed" ? true : false : null
        };
        employmentService.postEmployment(dataTransfer).then((response) => {
            reinstatementService.plsPostSection(store.currentApplicationId, sectionId, formModel.signature).then((data) => {
                reinstatementService.plsMarkSectionComplete(store.currentApplicationId, sectionId, isComplete).then((val) => {
                    if (response.data && val.data) {
                        nextSectionNavigation();
                    }
                    else if (response.data) {
                        var licensedFirmType = "";
                        if (response.data.firmIsLicensed)
                            licensedFirmType = "licensed";
                        else if (response.data.firmIsNotLicensed)
                            licensedFirmType = "unlicensed";
                        else if (response.data.soleProprietor)
                            licensedFirmType = "soleProprietor";
                        else if (response.data.unemployed)
                            licensedFirmType = "unemployed"
                        if (response.data.credentialId) {
                            getVfCredential(response.data.credentialId).then((cred) => {
                                setFormModel({
                                    id: response.data.id,
                                    employedBy: response.data.employedByName,
                                    firmNumber: cred,
                                    comment: response.data.comment,
                                    licensedFirmType: licensedFirmType
                                });
                                setOption(licensedFirmType);
                                Swal.fire("Saved!");
                            })
                        }
                        else {
                            setFormModel({
                                id: response.data.id,
                                employedBy: response.data.employedByName,
                                firmNumber: response.data.credentialId,
                                comment: response.data.comment,
                                licensedFirmType: licensedFirmType
                            });
                            setOption(licensedFirmType);
                            Swal.fire("Saved!");
                        }

                    }
                })
            })
        });
    }
    const nextSectionNavigation = () => {
        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
    }
    return (
        <div>
            <Container fluid>
                <FormEntityInformation {...entityInfo} />
                <Information content={GetReinstatementInformationContent("employment")} />
                <br />
                {hasLoaded ?
                    <Form fluid model={model} formValue={formModel} onChange={formModel => setFormModel(formModel)} onSubmit={formSubmit}>
                        <EmploymentLicensure firmNumber={formModel.firmNumber} licensedFirmType={formModel.licensedFirmType} option={option} setOption={setOption} clearFirmNumber={clearFirmNumber} isReadOnly={!isUserEditable} />
                        <br />
                        <Issues isUserEditable={isUserEditable} isInternal={true} type={2} sectionId={sectionData.id} setIsComplete={setIsComplete} />
                        <FormActionButtons
                            isReadOnly={!isUserEditable}
                            nextSectionCallback={nextSectionNavigation}
                            isUserEditable={isUserEditable}
                            isComplete={isComplete}
                            isCompleteCallback={setIsComplete}
                            showSectionComplete={true}
                            backToSectionLink="/internal/plsReinstatement/sections" />
                    </Form> : <LoadingSpinner />
                }
            </Container>
        </div>
    );
}
export default EmploymentPage